
(() => {
  const slider = document.querySelector('[data-hero-slider]');
  const slides = slider ? [...slider.querySelectorAll('.hero-slide')] : [];
  const productButtons = [...document.querySelectorAll('[data-product-view]')];
  const canWrap = document.querySelector('.product-pill-wrap');
  const productRail = document.querySelector('.product-rail');
  const productLabel = document.querySelector('[data-product-label]');
  const flavorPanel = document.querySelector('.flavor-panel');
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenuPanel = document.querySelector('.mobile-menu-panel');
  const mobileMenuScrim = document.querySelector('.mobile-menu-scrim');
  const CATS = [['tub', 'Electrolytes'], ['can', 'Sparkling Electrolytes'], ['energy', 'High-Stim Pre-Workout'], ['energycan', 'Sparkling Pre-Workout'], ['nostim', 'No-Stim Pre-Workout'], ['gear', 'Gear']];
  let activeProduct = 'tub';
  let activeIndex = 0;

  function setProduct(type) {
    const idx = Math.max(0, CATS.findIndex((c) => c[0] === type));
    activeIndex = idx;
    activeProduct = CATS[idx][0];
    document.body.dataset.currentProduct = activeProduct;

    if (activeProduct === 'can' || activeProduct === 'tub') {
      const heroIndex = activeProduct === 'can' ? 0 : 1;
      slides.forEach((slide, i) => slide.classList.toggle('active', i === heroIndex));
    }

    document.querySelectorAll('[data-product-card]').forEach((card) => card.classList.toggle('active', card.dataset.productCard === activeProduct));

    document.querySelectorAll('[data-product-view]').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.productView === activeProduct);
      if (btn.classList.contains('product-pill') && btn.closest('.product-pill-wrap')) btn.setAttribute('aria-expanded', String(activeProduct === 'can' && canWrap?.classList.contains('open')));
    });

    if (productLabel) productLabel.textContent = CATS[idx][1];
    if (productRail) productRail.scrollTo({ left: 0, behavior: 'instant' });
  }

  productButtons.forEach((btn) => btn.addEventListener('click', (event) => {
    const type = btn.dataset.productView;
    if (btn.matches('.hero-cta [data-product-view]')) event.preventDefault();
    setProduct(type);

    if (btn.closest('.product-pill-wrap')) {
      canWrap?.classList.toggle('open', btn.tagName !== 'A');
      if (btn.tagName !== 'A') event.preventDefault();
    } else {
      canWrap?.classList.remove('open');
    }
  }));

  function setMobileMenu(open, restoreFocus = false) {
    mobileMenuToggle?.setAttribute('aria-expanded', String(open));
    mobileMenuToggle?.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
    mobileMenuPanel?.classList.toggle('open', open);
    mobileMenuPanel?.setAttribute('aria-hidden', String(!open));
    mobileMenuScrim?.classList.toggle('open', open);
    document.body.classList.toggle('mobile-menu-open', open);
    if (open) mobileMenuPanel?.querySelector('a,button')?.focus();
    if (!open && restoreFocus) mobileMenuToggle?.focus();
  }

  mobileMenuToggle?.addEventListener('click', () => setMobileMenu(mobileMenuToggle.getAttribute('aria-expanded') !== 'true', true));
  mobileMenuScrim?.addEventListener('click', () => setMobileMenu(false, true));
  mobileMenuPanel?.querySelectorAll('a,button').forEach((item) => item.addEventListener('click', () => setMobileMenu(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenuToggle?.getAttribute('aria-expanded') === 'true') setMobileMenu(false, true);
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.product-pill-wrap')) canWrap?.classList.remove('open');
  });

  function scrollFlavor(direction) {
    // Arrows step through the categories; each category shows its own products.
    const next = (activeIndex + direction + CATS.length) % CATS.length;
    setProduct(CATS[next][0]);
  }

  flavorPanel?.querySelector('.flavor-nav.left')?.addEventListener('click', () => scrollFlavor(-1));
  flavorPanel?.querySelector('.flavor-nav.right')?.addEventListener('click', () => scrollFlavor(1));

  setProduct('tub');
})();

(() => {
  'use strict';

  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const menuButton = header.querySelector('[data-site-menu-toggle]');
  const menu = header.querySelector('[data-site-mobile-menu]');
  const searchButton = header.querySelector('[data-site-search-toggle]');
  const search = header.querySelector('[data-site-search-panel]');
  const searchInput = header.querySelector('[data-site-search-input]');
  const backdrop = header.querySelector('[data-site-header-backdrop]');
  const panels = [menu, search];
  let lastFocus = null;

  const isOpen = (panel) => Boolean(panel && !panel.hidden);

  function syncBackdrop() {
    if (backdrop) backdrop.hidden = !panels.some(isOpen);
  }

  function closePanel(panel, restoreFocus = false) {
    if (!panel) return;
    panel.hidden = true;
    if (panel === menu && menuButton) menuButton.setAttribute('aria-expanded', 'false');
    if (panel === search && searchButton) searchButton.setAttribute('aria-expanded', 'false');
    syncBackdrop();
    if (restoreFocus && lastFocus?.focus) lastFocus.focus();
  }

  function closeAll(restoreFocus = false) {
    panels.forEach((panel) => closePanel(panel, false));
    if (restoreFocus && lastFocus?.focus) lastFocus.focus();
  }

  function openPanel(panel, button) {
    if (!panel || !button) return;
    lastFocus = button;
    panels.forEach((other) => {
      if (other !== panel) closePanel(other, false);
    });
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    syncBackdrop();
  }

  menuButton?.addEventListener('click', () => {
    if (isOpen(menu)) closePanel(menu, true);
    else openPanel(menu, menuButton);
  });

  searchButton?.addEventListener('click', () => {
    if (isOpen(search)) closePanel(search, true);
    else {
      openPanel(search, searchButton);
      requestAnimationFrame(() => searchInput?.focus());
    }
  });

  backdrop?.addEventListener('click', () => closeAll(true));
  header.querySelectorAll('[data-site-mobile-menu] a').forEach((link) => {
    link.addEventListener('click', () => closeAll(false));
  });

  addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panels.some(isOpen)) {
      event.preventDefault();
      closeAll(true);
    }
  });

  addEventListener('resize', () => {
    if (innerWidth > 1080) closePanel(menu, false);
  });

  const path = location.pathname.toLowerCase();
  let route = 'home';
  if (path.includes('/collections') || path.includes('/products') || path.includes('/search')) route = 'products';
  else if (path.includes('affiliates')) route = 'affiliates';
  else if (path.includes('wholesale')) route = 'wholesale';

  header.querySelectorAll('[data-site-route]').forEach((link) => {
    if (link.dataset.siteRoute === route) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });

  const params = new URLSearchParams(location.search);
  const activeFormat = route === 'products'
    ? ({ tubs: 'tub', cans: 'can' }[params.get('category')] || '')
    : route === 'product'
      ? (params.get('format') === 'can' ? 'can' : 'tub')
      : '';

  header.querySelectorAll('.site-format-nav__choice').forEach((link) => {
    const format = link.href.includes('category=tubs') ? 'tub' : 'can';
    if (format === activeFormat) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });

  if (typeof HTMLDialogElement === 'undefined') return;

  const dialog = document.createElement('dialog');
  dialog.className = 'site-qv';
  dialog.setAttribute('aria-labelledby', 'site-qv-title');
  dialog.innerHTML = `
    <article class="site-qv__panel">
      <button class="site-qv__close" type="button" aria-label="Close quick info">×</button>
      <img class="site-qv__image" alt="">
      <span class="site-qv__tag"></span>
      <h2 class="site-qv__title" id="site-qv-title"></h2>
      <p class="site-qv__description"></p>
      <div class="site-qv__formula">
        <section><h3>Inside The Formula</h3><ul data-qv-ingredients></ul></section>
        <section><h3>Why It Stands Out</h3><ul data-qv-benefits></ul></section>
      </div>
      <p class="site-qv__warning" data-qv-warning hidden></p>
      <label class="site-qv__field" for="site-qv-flavor">Choose Another Flavor</label>
      <select class="site-qv__select" id="site-qv-flavor" data-qv-flavor></select>
      <p class="site-qv__status" data-qv-status aria-live="polite"></p>
      <div class="site-qv__purchase" data-qv-purchase>
        <a class="site-qv__buy" data-qv-buy>Buy now</a>
        <form class="site-qv__cart-form" method="post" action="/cart/add" data-qv-cart-form>
          <input type="hidden" name="id" data-qv-variant>
          <input type="hidden" name="quantity" value="1">
          <button type="submit" name="add">Add to cart</button>
        </form>
      </div>
      <div class="site-qv__actions">
        <a class="site-qv__details" data-qv-full-details>View full details</a>
        <button class="site-qv__continue" type="button">Continue browsing</button>
      </div>
    </article>`;
  document.body.append(dialog);

  const quickViewImage = dialog.querySelector('.site-qv__image');
  const quickViewTag = dialog.querySelector('.site-qv__tag');
  const quickViewTitle = dialog.querySelector('.site-qv__title');
  const quickViewDescription = dialog.querySelector('.site-qv__description');
  const quickViewIngredients = dialog.querySelector('[data-qv-ingredients]');
  const quickViewBenefits = dialog.querySelector('[data-qv-benefits]');
  const quickViewWarning = dialog.querySelector('[data-qv-warning]');
  const quickViewFlavor = dialog.querySelector('[data-qv-flavor]');
  const quickViewStatus = dialog.querySelector('[data-qv-status]');
  const quickViewPurchase = dialog.querySelector('[data-qv-purchase]');
  const quickViewBuy = dialog.querySelector('[data-qv-buy]');
  const quickViewCartForm = dialog.querySelector('[data-qv-cart-form]');
  const quickViewVariant = dialog.querySelector('[data-qv-variant]');
  const quickViewDetails = dialog.querySelector('[data-qv-full-details]');
  const quickViewClose = dialog.querySelector('.site-qv__close');
  const quickViewContinue = dialog.querySelector('.site-qv__continue');
  let quickViewTrigger = null;
  let quickViewCard = null;

  const productLinkFor = (card) => card.matches('a[href]') ? card : card.querySelector('.catalog-card__link[href]');

  function cardInfo(card) {
    const link = productLinkFor(card);
    const url = new URL(link?.href || '/collections/all', location.href);
    const category = card.dataset.category || '';
    const line = category === 'energy' || category === 'energycan' ? 'energy' : ['tub','can'].includes(category) ? 'juice' : category;
    const format = category === 'can' || category === 'energycan' ? 'can' : 'tub';
    return { card, link, url, line, format, category, flavor: card.querySelector('h3')?.textContent.trim() || '' };
  }

  function formulaFor(info) {
    const content = info.card.querySelector('template[data-product-copy]')?.content;
    return {
      summary: content?.querySelector('[data-product-summary]')?.textContent.trim() || info.card.querySelector('.card-body p')?.textContent.trim() || '',
      ingredients: [],
      benefits: [...(content?.querySelectorAll('[data-product-highlights] li') || [])].map(item => item.textContent.trim())
    };
  }

  function renderList(list, values) {
    list.replaceChildren(...values.map((value) => {
      const item = document.createElement('li');
      item.textContent = value;
      return item;
    }));
  }

  function matchingCards(info) {
    return [...document.querySelectorAll('.catalog-card')].filter((candidate) => {
      const candidateInfo = cardInfo(candidate);
      return candidateInfo.category === info.category;
    });
  }

  function renderQuickView(card) {
    const info = cardInfo(card);
    const formula = formulaFor(info);
    const image = card.querySelector('img');
    const title = card.querySelector('h3');
    const tag = card.querySelector('.product-tag, .format-tag');
    if (!image || !title) return;

    quickViewCard = card;
    quickViewImage.src = image.currentSrc || image.src;
    quickViewImage.alt = image.alt || `${title.textContent.trim()} product preview`;
    quickViewTag.textContent = tag?.textContent.trim() || 'Undisputed Nutrition';
    quickViewTitle.textContent = title.textContent.trim();
    quickViewDescription.textContent = formula.summary;
    renderList(quickViewIngredients, formula.ingredients);
    quickViewIngredients.closest('section').hidden = true;
    renderList(quickViewBenefits, formula.benefits);
    quickViewWarning.hidden = !formula.warning;
    quickViewWarning.textContent = formula.warning || '';

    const groupCards = matchingCards(info);
    const hasChoices = groupCards.length > 1 && info.category !== 'gear' && info.category !== 'travel';
    quickViewFlavor.hidden = !hasChoices;
    dialog.querySelector('.site-qv__field').hidden = !hasChoices;
    quickViewFlavor.replaceChildren(...groupCards.map((candidate) => {
      const candidateInfo = cardInfo(candidate);
      const option = document.createElement('option');
      option.value = candidateInfo.flavor;
      option.textContent = `${candidateInfo.flavor}${candidate.dataset.cartAvailable === 'false' ? ' — Sold out' : ''}`;
      option.selected = candidate === card;
      return option;
    }));

    const variant = card.dataset.cartVariant || '';
    const available = Number(card.dataset.optionCount || 1) === 1 && card.dataset.cartAvailable === 'true' && Boolean(variant);
    const price = card.querySelector('.price strong')?.textContent.trim() || '';
    quickViewPurchase.hidden = !available;
    if (available) {
      quickViewBuy.href = `/cart/${variant}:1?checkout`;
      quickViewVariant.value = variant;
      quickViewStatus.textContent = `${price} · In stock`;
    } else if (card.dataset.cartAvailable === 'false') {
      quickViewStatus.textContent = `${price} · Currently sold out`;
    } else {
      quickViewStatus.textContent = Number(card.dataset.optionCount || 1) > 1 ? 'Choose your options on the product page.' : 'This product is not available for purchase right now.';
    }

    quickViewDetails.removeAttribute('target');
    quickViewDetails.removeAttribute('rel');
    quickViewDetails.href = info.link?.getAttribute('href') || '/collections/all';
    quickViewDetails.textContent = Number(card.dataset.optionCount || 1) > 1 ? 'Choose options' : 'View full details';
  }

  function closeQuickView() {
    if (dialog.open) dialog.close();
  }

  function openQuickView(card, trigger) {
    quickViewTrigger = trigger;
    renderQuickView(card);
    dialog.showModal();
    document.body.classList.add('site-qv-open');
    requestAnimationFrame(() => quickViewClose.focus());
  }

  quickViewFlavor.addEventListener('change', () => {
    if (!quickViewCard) return;
    const info = cardInfo(quickViewCard);
    const selected = matchingCards(info).find((candidate) => cardInfo(candidate).flavor === quickViewFlavor.value);
    if (selected) renderQuickView(selected);
  });

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-quick-info]');
    const card = trigger?.closest('.flavor-card, .catalog-card');
    if (!trigger || !card) return;
    event.preventDefault();
    openQuickView(card, trigger);
  });

  quickViewClose.addEventListener('click', closeQuickView);
  quickViewContinue.addEventListener('click', closeQuickView);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeQuickView();
  });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('site-qv-open');
    quickViewCard = null;
    requestAnimationFrame(() => quickViewTrigger?.focus());
  });

  const matchOpen = document.querySelector('[data-product-match-open]');
  if (!matchOpen) return;

  const matchDialog = document.createElement('dialog');
  matchDialog.className = 'product-match';
  matchDialog.setAttribute('data-product-match', '');
  matchDialog.setAttribute('aria-labelledby', 'product-match-title');
  matchDialog.innerHTML = `
    <article class="product-match__panel">
      <header class="product-match__header">
        <div><span class="product-match__eyebrow">Undisputed Product Match</span><h2 id="product-match-title">Find what fits your routine</h2></div>
        <button class="product-match__close" type="button" data-match-close aria-label="Close product match">×</button>
      </header>
      <div class="product-match__progress-wrap" data-match-progress-wrap>
        <span class="product-match__progress" data-match-progress>1 of 3</span>
        <span class="product-match__bar" aria-hidden="true"><i data-match-bar></i></span>
      </div>
      <section class="product-match__step" data-match-step>
        <h3 data-match-question></h3>
        <p data-match-help></p>
        <div class="product-match__choices" data-match-choices></div>
        <div class="product-match__nav">
          <button class="product-match__back" type="button" data-match-back>Back</button>
          <button class="product-match__next" type="button" data-match-next disabled>Next</button>
        </div>
      </section>
      <section class="product-match__result" data-match-result hidden>
        <img data-match-result-image alt="">
        <div class="product-match__result-copy">
          <span class="product-match__eyebrow">Your Product Match</span>
          <h3 data-match-result-title></h3>
          <p class="product-match__result-intro">Why it fits your routine:</p>
          <ul data-match-result-reasons></ul>
          <p class="product-match__status" data-match-result-status></p>
          <div class="product-match__result-actions" data-match-result-actions>
            <a data-match-result-details>View Full Details</a>
            <button type="button" data-match-result-quick>Quick Info</button>
          </div>
          <p class="product-match__disclaimer">This is a product guide, not medical advice. Review the product label and warnings; caffeine-sensitive shoppers should consult an appropriate healthcare professional before using high-stimulant products.</p>
          <button class="product-match__restart" type="button" data-match-restart>Start Over</button>
        </div>
      </section>
    </article>`;
  document.body.append(matchDialog);

  const matchSteps = [
    {
      question: 'What is your main goal?',
      help: 'Choose the routine you want this product to support.',
      choices: [
        ['hydration-daily', 'Daily Hydration', 'Stimulant-free hydration you mix into your routine'],
        ['hydration-onthego', 'Grab-and-Go Hydration', 'Stimulant-free hydration in a ready-to-drink format'],
        ['preworkout', 'High-Stim Pre-Workout', 'ENERGY for a stimulant-based pre-training routine'],
        ['nostim', 'No-Stim Pre-Workout', 'JUICE Plus+ for a stimulant-free pre-training routine'],
      ],
    },
    {
      question: 'Which format fits your routine?',
      help: 'Pick the way you would most naturally use it.',
      choices: [
        ['tub', 'Mix-at-Home Tub', 'Scoop, mix, and control when it enters your routine'],
        ['can', 'Ready-to-Drink Can', 'Portable convenience with no mixing'],
        ['either', 'Either Works', 'Recommend the strongest fit across both formats'],
      ],
    },
    {
      question: 'Which flavor profile sounds best?',
      help: 'We will match this when it is available in the right formula and format.',
      choices: [
        ['blueberry', 'Blueberry + Lemon', 'Cool berry with a citrus finish'],
        ['dragon', 'Dragon Fruit + Pomegranate', 'Bold red-fruit flavor'],
        ['citrus', 'Bright Citrus', 'Orange-forward and crisp'],
        ['raspberry', 'Raspberry + Lime + Mint', 'Tart berry with a cool finish'],
        ['strawberry', 'Strawberry + Lemon', 'Sweet berry and sharp citrus'],
        ['surprise', 'Surprise Me', 'Choose the closest overall routine match'],
      ],
    },
  ];
  const matchFlavorNames = {
    blueberry: 'Blueberry Lemonade',
    dragon: "Dragon's Blood",
    citrus: 'Jolly Roger Orange',
    raspberry: 'Raspberry Mojito',
    strawberry: 'Strawberry Lemonade',
  };
  const matchState = { step: 0, answers: [null, null, null], trigger: null, card: null };
  const matchStep = matchDialog.querySelector('[data-match-step]');
  const matchProgressWrap = matchDialog.querySelector('[data-match-progress-wrap]');
  const matchProgress = matchDialog.querySelector('[data-match-progress]');
  const matchBar = matchDialog.querySelector('[data-match-bar]');
  const matchQuestion = matchDialog.querySelector('[data-match-question]');
  const matchHelp = matchDialog.querySelector('[data-match-help]');
  const matchChoices = matchDialog.querySelector('[data-match-choices]');
  const matchBack = matchDialog.querySelector('[data-match-back]');
  const matchNext = matchDialog.querySelector('[data-match-next]');
  const matchResult = matchDialog.querySelector('[data-match-result]');
  const matchResultImage = matchDialog.querySelector('[data-match-result-image]');
  const matchResultTitle = matchDialog.querySelector('[data-match-result-title]');
  const matchResultReasons = matchDialog.querySelector('[data-match-result-reasons]');
  const matchResultStatus = matchDialog.querySelector('[data-match-result-status]');
  const matchResultActions = matchDialog.querySelector('[data-match-result-actions]');
  const matchResultDetails = matchDialog.querySelector('[data-match-result-details]');
  const matchResultQuick = matchDialog.querySelector('[data-match-result-quick]');
  const matchClose = matchDialog.querySelector('[data-match-close]');
  const matchRestart = matchDialog.querySelector('[data-match-restart]');

  function matchCards() {
    return [...document.querySelectorAll('.catalog-card')].map((card) => ({ ...cardInfo(card), card }));
  }

  function matchFormat(info) {
    return info.format;
  }

  function chooseMatch() {
    const [goal, requestedFormat, flavorKey] = matchState.answers;
    const targetLine = goal === 'preworkout' ? 'energy' : goal === 'nostim' ? 'nostim' : 'juice';
    const family = matchCards().filter(info => info.line === targetLine);
    const goalFormat = goal === 'hydration-onthego' ? 'can' : 'tub';
    const format = requestedFormat === 'either' ? goalFormat : requestedFormat;
    const formatMatches = family.filter(info => info.format === format);
    const candidates = formatMatches.length ? formatMatches : family;
    const preferred = matchFlavorNames[flavorKey];
    return candidates.find(info => preferred && info.flavor.toLowerCase().includes(preferred.toLowerCase()) && info.card.dataset.cartAvailable === 'true')
      || candidates.find(info => info.card.dataset.cartAvailable === 'true')
      || candidates[0] || null;
  }

  function reasonsFor(info) {
    const reasons = [formulaFor(info).summary];
    const requestedFormat = matchState.answers[1];
    if (requestedFormat !== 'either' && info.format !== requestedFormat) reasons.push('This product family is available in a different format from your selection.');
    return reasons.filter(Boolean);
  }

  function renderMatchStep() {
    const step = matchSteps[matchState.step];
    matchStep.hidden = false;
    matchResult.hidden = true;
    matchProgressWrap.hidden = false;
    matchProgress.textContent = `${matchState.step + 1} of ${matchSteps.length}`;
    matchBar.style.width = `${((matchState.step + 1) / matchSteps.length) * 100}%`;
    matchQuestion.textContent = step.question;
    matchHelp.textContent = step.help;
    matchChoices.replaceChildren(...step.choices.map(([value, title, detail]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-match__choice';
      button.dataset.matchChoice = value;
      button.setAttribute('aria-pressed', String(matchState.answers[matchState.step] === value));
      button.innerHTML = `<strong>${title}</strong><span>${detail}</span>`;
      return button;
    }));
    matchBack.hidden = matchState.step === 0;
    matchNext.disabled = !matchState.answers[matchState.step];
    matchNext.textContent = matchState.step === matchSteps.length - 1 ? 'Show My Match' : 'Next';
    requestAnimationFrame(() => matchQuestion.focus?.());
  }

  function renderMatchResult() {
    const info = chooseMatch();
    if (!info) {
      matchStep.hidden=true;matchProgressWrap.hidden=true;matchResult.hidden=false;
      matchResultImage.hidden=true;matchResultTitle.textContent='No matching product in this collection.';
      matchResultReasons.replaceChildren();matchResultStatus.textContent='Try Shop All to see the full lineup.';
      matchResultActions.hidden=true;return;
    }
    matchResultImage.hidden=false;matchResultActions.hidden=false;
    const card = info.card;
    matchState.card = card;
    const image = card.querySelector('img');
    const title = card.querySelector('h3')?.textContent.trim() || 'Undisputed Product';
    const reasons = reasonsFor(info);
    matchStep.hidden = true;
    matchProgressWrap.hidden = true;
    matchResult.hidden = false;
    matchResultImage.src = image?.currentSrc || image?.src || '';
    matchResultImage.alt = image?.alt || `${title} product match`;
    matchResultTitle.textContent = title;
    renderList(matchResultReasons, reasons);
    matchResultDetails.href = info.link?.getAttribute('href') || '/collections/all';
    matchResultActions.querySelector('[data-match-result-buy]')?.remove();
    const variant = card.dataset.cartVariant || '';
    const available = Number(card.dataset.optionCount || 1) === 1 && card.dataset.cartAvailable === 'true' && Boolean(variant);
    if (available) {
      matchResultStatus.textContent = 'In stock and ready to ship.';
      const buy = document.createElement('a');
      buy.dataset.matchResultBuy = '';
      buy.className = 'product-match__buy';
      buy.href = `/cart/${variant}:1?checkout`;
      buy.textContent = 'Buy Now';
      matchResultActions.prepend(buy);
    } else if (card.dataset.cartAvailable === 'false') {
      matchResultStatus.textContent = 'Currently sold out. Explore the details or restart for another match.';
    } else {
      matchResultStatus.textContent = 'This product is not available for purchase right now.';
    }
    requestAnimationFrame(() => matchResultTitle.focus?.());
  }

  function resetMatch() {
    matchState.step = 0;
    matchState.answers = [null, null, null];
    matchState.card = null;
    renderMatchStep();
  }

  function closeMatch() {
    if (matchDialog.open) matchDialog.close();
  }

  function openMatch(trigger) {
    if (dialog.open) closeQuickView();
    matchState.trigger = trigger;
    resetMatch();
    matchDialog.showModal();
    document.body.classList.add('product-match-open');
    requestAnimationFrame(() => matchClose.focus());
  }

  matchOpen.addEventListener('click', () => openMatch(matchOpen));
  matchChoices.addEventListener('click', (event) => {
    const choice = event.target instanceof Element ? event.target.closest('[data-match-choice]') : null;
    if (!choice) return;
    matchState.answers[matchState.step] = choice.dataset.matchChoice;
    matchChoices.querySelectorAll('[data-match-choice]').forEach((button) => button.setAttribute('aria-pressed', String(button === choice)));
    matchNext.disabled = false;
  });
  matchNext.addEventListener('click', () => {
    if (!matchState.answers[matchState.step]) return;
    if (matchState.step === matchSteps.length - 1) renderMatchResult();
    else { matchState.step += 1; renderMatchStep(); }
  });
  matchBack.addEventListener('click', () => {
    if (matchState.step > 0) { matchState.step -= 1; renderMatchStep(); }
  });
  matchClose.addEventListener('click', closeMatch);
  matchRestart.addEventListener('click', resetMatch);
  matchResultQuick.addEventListener('click', () => {
    const card = matchState.card;
    const trigger = card?.querySelector('[data-quick-info]');
    closeMatch();
    if (card && trigger) requestAnimationFrame(() => openQuickView(card, trigger));
  });
  matchDialog.addEventListener('click', (event) => { if (event.target === matchDialog) closeMatch(); });
  matchDialog.addEventListener('cancel', (event) => { event.preventDefault(); closeMatch(); });
  matchDialog.addEventListener('close', () => {
    document.body.classList.remove('product-match-open');
    requestAnimationFrame(() => matchState.trigger?.focus());
  });
})();

(() => {
  const pending = new WeakSet();
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented || form.closest('product-form')) return;
    if (!new URL(form.action, location.href).pathname.endsWith('/cart/add')) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);
    const button = event.submitter || form.querySelector('[type="submit"]');
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    let added = false;
    try {
      const data = new FormData(form);
      data.set('sections', 'cart-drawer,cart-icon-bubble');
      data.set('sections_url', location.pathname + location.search);
      const response = await fetch(new URL('add.js', form.action.endsWith('/') ? form.action : form.action.replace(/add$/, '')), {method:'POST',headers:{Accept:'application/json'},body:data});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add to cart.');
      added = true;
      document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      drawer.classList.remove('is-empty');
      if (!result.sections?.['cart-drawer']) { location.assign('/cart'); return; }
      drawer.setActiveElement?.(button);
      drawer.renderContents({id:result.id || result.items?.[0]?.id,sections:result.sections});
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:result}));
    } catch (error) {
      if (added) { location.assign('/cart'); return; }
      let status = form.querySelector('[data-cart-error]');
      if (!status) { status=document.createElement('p');status.dataset.cartError='';status.setAttribute('role','alert');form.append(status); }
      status.textContent=error.message || 'Could not confirm the cart update. Check your bag before trying again.';
    } finally {
      pending.delete(form);
      if (button) { button.disabled=false;button.removeAttribute('aria-busy'); }
    }
  });
  document.querySelectorAll('a.site-icon-button[href*="/cart"]').forEach(link => {
    link.addEventListener('click',event => {
      const drawer=document.querySelector('cart-drawer');
      if (!drawer) return;
      event.preventDefault();drawer.open(link);
    });
  });
})();
document.addEventListener('click', async event => {
  const link=event.target.closest('a[data-qv-buy],a.product-match__buy,a.card-action--buy');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const match=(link.getAttribute('href')||'').match(/\/cart\/(\d+):(\d+)/);
  if (!match) return;
  event.preventDefault();
  if (link.getAttribute('aria-busy')==='true') return;
  link.setAttribute('aria-busy','true');
  try {
    const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(match[1]),quantity:Number(match[2])||1}]})});
    if (!response.ok) throw new Error('Could not add this item.');
    location.assign('/checkout');
  } catch (error) { location.assign('/cart'); }
  finally { link.removeAttribute('aria-busy'); }
});
